module.exports = __webpack_public_path__ + "static/img/130.ebf0f3ac.png";